import React from 'react'
import logo from '../../logo/ahil-logo.png'
import { ThemeContext } from '../../theme/DarkMode';
import { ActionButton } from './ActionButton';
import '@material/web/button/text-button';
import '@material/web/iconbutton/standard-icon-button.js';
import { Fab } from './Fab';
import { NavLink } from 'react-router-dom';
import { MenuItem } from './MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import { BurgerNavbar } from './BurgerNavbar';

export const Navbar = () => {

    const { theme } = React.useContext(ThemeContext);
    const [display, setDiplay] = React.useState(false)

    const [scrollPosition, setScrollPosition] = React.useState(0);

    React.useEffect(() => {
        if (typeof window !== "undefined") {

            const handleScroll = () => {
                const position = window.scrollY;
                setScrollPosition(position);
            }

            window.addEventListener("scroll", handleScroll);

            return () => window.removeEventListener("scroll", handleScroll);
        }
    }, [scrollPosition])

    const openMnue = () => {
        setDiplay(true)
    }

    return (
        <>
            <header className={theme === 'light' ? 'light-navbar-wrapper' : 'navbar-wrapper'}>
                <div className='menu-icon'>
                    <md-standard-icon-button onClick={openMnue}>
                        <MenuIcon sx={{ cursor: 'pointer', color: theme === 'light' ? '#1c1b1e' : '#fffbff', width: '25px', height: '25px'}} />
                    </md-standard-icon-button>
                </div>
                <NavLink to='/'>
                    <img src={logo} alt='ahil logo' className='ahil-logo-navbar' />
                </NavLink>
                <MenuItem />
                <ActionButton />
                {scrollPosition > 500 ?
                    <Fab />
                    : null}
            </header>
            {display ? <BurgerNavbar setDiplay={setDiplay} /> : null}
        </>
    )
}